export default "__VITE_ASSET__Ns5OqGvU__"